/*
Copyright (C) 2024 Laboratorio Visao Robotica e Imagem

Departamento de Informatica - Universidade Federal do Parana - VRI/UFPR

This file is part of CienciaNaEscola. CienciaNaEscola is free software: you can redistribute it and/or modify it under the terms of the GNU
General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
CienciaNaEscola is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for more details. You should have received a copy
of the GNU General Public License along with CienciaNaEscola.  If not, see <https://www.gnu.org/licenses/>
*/

import Gallery from '../../Gallery';
import MarkdownText from '../../MarkdownText';

const styles = `
    .font-barlow {
        font-family: 'Barlow', sans-serif;
    }

    .bg-grey {
        background-color: #D9D9D9
    }

    .color-dark-gray {
        color: #535353;
    }
`;

/**
 * Componente responsável por exibir um texto formatado em Markdown e uma galeria de imagens.
 * @param {Object} props - Propriedades do componente.
 * @param {Object} props.item - Objeto representando o item da pergunta, contendo o texto e imagens.
 * @param {Object} props.galleryModalRef - Referência para o modal da galeria de imagens.
 */
function TextImageInput(props) {
    const { item, galleryModalRef } = props;

    return (
        <div className="rounded-4 shadow bg-white p-3 pb-0">
            <div className="row m-0">
                <MarkdownText text={item.text} />
            </div>

            <Gallery className="mb-3" item={item} galleryModalRef={galleryModalRef} />

            <style>{styles}</style>
        </div>
    );
}

export default TextImageInput;
